export default __webpack_public_path__ + "static/media/icon_close_20_Regular_green.515c5cc1.svg";